module.exports = __webpack_public_path__ + "static/media/sick-certificate-prescription.e7167713.svg";